import { password } from '@/@core/utils/validations/validations'
import Vue from 'vue'
import VueRouter from 'vue-router'
import {createRouter,createWebHistory} from 'vue-router'
import dashboard from './routes/dashboard'
import login from './routes/login'
import profile from './routes/profile'
import forgotPassword from './routes/forgotPassword'
import roles from './routes/roles'
import jobs from './routes/jobs'
import organizations from './routes/organizations'
import divisions from './routes/divisions'
import departments from './routes/departments'
import employees from './routes/employees'
import attendances from './routes/attendances'
import overtimes from './routes/overtimes'
import permits from './routes/permits'
import reimbursements from './routes/reimbursements'
import cashAdvance from './routes/cashAdvance'
import payrolls from './routes/payrolls'
import employeeStatus from './routes/employeeStatus'
import employeePtkp from './routes/employeePtkp'
import company from './routes/company'
import units from './routes/units'
import categories from './routes/categories'
import products from './routes/products'
import currency from './routes/currency'
import vendorCategory from './routes/vendorCategory'
import vendor from './routes/vendor'
import paymentType from './routes/paymentType'
import shippingType from './routes/shippingType'
import customerCategory from './routes/customerCategory'
import customer from './routes/customer'
import quotation from './routes/quotation'
import order from './routes/order'
import warehouseLocation from './routes/warehouseLocation'
import binLocation from './routes/binLocation'
import item from './routes/item'
import fulfillmentRequest from './routes/fulfillmentRequest'
import permitQuota from './routes/permitQuota'
import shipping from './routes/shipping'
import catalog from './routes/catalog'
import purchase from './routes/purchase'
import procurementReceiving from './routes/procurementReceiving'
import warehouseReceiving from './routes/warehouseReceiving'
import transfer from './routes/transfer'
import replenishment from './routes/replenishment'
import warehouseBorrowRequest from './routes/warehouseBorrowRequest'
import stockOpname from './routes/stockOpname'
import salesBorrowRequest from './routes/salesBorrowRequest'
import task from './routes/task'
import target from './routes/target'
import assetCategory from './routes/assetCategory'
import assetLocations from './routes/assetLocations'
import assetItem from './routes/assetItem'
import assetMovement from './routes/assetMovement'
import assetMaintenance from './routes/assetMaintenance'
import accountType from './routes/accountType'
import accounts from './routes/accounts'
import payable from './routes/payable'
import receivable from './routes/receivable'
import financeTransfer from './routes/financeTransfer'
import procurementPayment from './routes/procurementPayment'
import procurementReturn from './routes/procurementReturn'
import financeJournal from './routes/financeJournal'
import error404 from './routes/error404'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    ...dashboard,
    ...login,
    ...profile,
    ...forgotPassword,
    ...roles,
    ...jobs,
    ...organizations,
    ...divisions,
    ...departments,
    ...employees,
    ...attendances,
    ...overtimes,
    ...permits,
    ...reimbursements,
    ...cashAdvance,
    ...payrolls,
    ...employeeStatus,
    ...employeePtkp,
    ...company,
    ...units,
    ...categories,
    ...products,
    ...currency,
    ...vendorCategory,
    ...vendor,
    ...paymentType,
    ...shippingType,
    ...customerCategory,
    ...customer,
    ...quotation,
    ...order,
    ...warehouseLocation,
    ...binLocation,
    ...item,
    ...fulfillmentRequest,
    ...permitQuota,
    ...shipping,
    ...catalog,
    ...purchase,
    ...procurementReceiving,
    ...warehouseReceiving,
    ...transfer,
    ...replenishment,
    ...warehouseBorrowRequest,
    ...stockOpname,
    ...salesBorrowRequest,
    ...task,
    ...target,
    ...assetCategory,
    ...assetLocations,
    ...assetItem,
    ...assetMovement,
    ...assetMaintenance,
    ...accountType,
    ...accounts,
    ...payable,
    ...receivable,
    ...financeTransfer,
    ...procurementPayment,
    ...procurementReturn,
    ...financeJournal,
    ...error404,
  ],
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
// router.afterEach(() => {
//   // Remove initial loading
//   const appLoading = document.getElementById('loading-bg')
//   if (appLoading) {
//     appLoading.style.display = 'none'
//   }
// })

router.beforeEach((to, from, next) => {
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
  
  const isAuthenticated = JSON.parse(sessionStorage.getItem('authenticated'));
  if (to.name !== 'login' && to.name !== 'forgot-password' && !isAuthenticated) next({ path: '/login' });
  // else if (to.name !== 'login' && !isAuthenticated) next({ path: '/' });
  else next();
});

export default router
